import { COLORS } from "../../assets/utils/enums/colors";
import { HeadlineTypeEnum } from "../../assets/utils/enums/headline";
import { ThemeTypeEnum } from "../../assets/utils/validation/types";
import AppLayout from "../../components/layout/app/layout";
import Headline from "../../components/ui/headline";
import StatisticBlock, {
  DataStatisticProps,
} from "../../components/ui/statistics-block";
import projectWhiteIcon from "../../assets/images/icons/projects-white-icon.svg";
import pieIcon from "../../assets/images/icons/pie-one-icon.svg";
import basketIcon from "../../assets/images/icons/basket-icon.svg";
import DataTable from "../../components/ui/table";
import { tableColumnType, TableTypeEnum } from "../../assets/utils/enums/table";
import { useEffect, useState } from "react";
import getData from "../../api/project-request";
import { API_URL_PROJECT } from "../../constants";
import { currencies } from "../../assets/utils/data/items";
import { ProjectRow } from "../../assets/utils/table-types";
import { useStatisticPeriod } from "../../assets/store/useStatisticPeriod";
import { deleteArrFunc } from "../../assets/utils/request-function";
import { findStructureFieldByKey, useStructureStore } from "../../assets/store/useStructureStore";
import { ObjectsEnum } from "../../assets/utils/enums/basket";
import { useStructureColumnsStore } from "../../assets/store/useStructureColumnsStore";

export default function ProjectsMainPage() {
  const [projects, setProjects] = useState<ProjectRow[]>([]);
  const [projStatistic, setProjStatistic] = useState<DataStatisticProps[]>([]);
  const [finStatistic, setFinStatistic] = useState<DataStatisticProps[]>([]);
  const [sellStatistic, setSellStatistic] = useState<DataStatisticProps[]>([]);
  const [loaderState, setLoaderState] = useState<boolean>(false);
  const [isDeleted, setIsDeleted] = useState<boolean>(false);
  const { period } = useStatisticPeriod();
  const fields = useStructureStore(
    (s) => s.structures[ObjectsEnum.PROJECTS].fields
  )
  const baseColumns =
    tableColumnType[TableTypeEnum.PROJECTS].columns;

  const tableStructure = useStructureColumnsStore(
    baseColumns,
    fields
  );

  const getProjects = async () => {
    setLoaderState(true);
    try {
      const data = await getData(`${API_URL_PROJECT}/table`);

      if (Array.isArray(data)) {
        setProjects(data);
      } else {
        setProjects([]);
      }
    } catch (error: any) {
      console.log(error.message);
      setProjects([]);
    } finally {
      setTimeout(() => {
        setLoaderState(false);
      }, 100);
    }
  };

  useEffect(() => {
    getProjects();
  }, []);

  useEffect(() => {
    getProjects();
    setIsDeleted(false);
  }, [isDeleted]);

  useEffect(() => {
    const getStatisticProject = async () => {
      const data = await getData(`${API_URL_PROJECT}/summary?period=${period}`);
      setProjStatistic([
        { title: "Всі проєкти", value: data.totalProjects, percent: "" },
        {
          title: "Активні проєкти",
          value: data.activeProjects,
          percent: data.activeProjectsChange,
        },
      ]);
    };
    const getStatisticFinance = async () => {
      const data = await getData(
        `${API_URL_PROJECT}/finance-summary?period=${period}&currency=${currencies[1].code}`
      );
      setFinStatistic([
        ...(findStructureFieldByKey(fields, "allIncome")?.visible
          ? [{
            title: findStructureFieldByKey(fields, "allIncome")?.label ?? "Надходження",
            value: data.formattedIncomes,
            percent: `${data.incomesChangePercent}`,
          }]
          : []),

        ...(findStructureFieldByKey(fields, "allExpense")?.visible
          ? [{
            title: findStructureFieldByKey(fields, "allExpense")?.label ?? "Витрати",
            value: data.formattedExpenses,
            percent: `${data.expensesChangePercent}`,
          }]
          : []),
      ]);
    };
    const getStatisticSelling = async () => {
      const data = await getData(
        `${API_URL_PROJECT}/selling-summary?period=${period}`
      );
      setSellStatistic([
        { title: "Всі продажі", value: data.totalSellings, percent: "" },
        { title: "В процесі", value: data.inProgressSellings, percent: "" },
        {
          title: "Завершені",
          value: data.completedSellings,
          percent: data.completedChangePercent,
        },
      ]);
    };

    setLoaderState(true);
    setTimeout(() => {
      getStatisticProject();
      getStatisticFinance();
      getStatisticSelling();
      setLoaderState(false);
    }, 200);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [period, isDeleted]);

  return (
    <AppLayout className="" blockType="projects" loaderState={loaderState}>
      <Headline
        headline={HeadlineTypeEnum.PROJECTS}
        theme={ThemeTypeEnum.LIGHT}
        btn_text="Додати проєкт"
        btn_link="/projects/add"
        isEdit={false}
      />
      <div
        data-class="statistics-block"
        className="align-items-center w-100 flex-wrap"
      >
        <StatisticBlock
          key={4}
          iconColor={COLORS.secondary1}
          iconUrl={projectWhiteIcon}
          bgColor={COLORS.blue}
          isDropdown={true}
          data={projStatistic}
        />
        <StatisticBlock
          key={6}
          iconColor={COLORS.secondary1}
          iconUrl={basketIcon}
          bgColor={COLORS.white}
          isDropdown={true}
          data={sellStatistic}
        />
        {(findStructureFieldByKey(fields, "allIncome")?.visible || findStructureFieldByKey(fields, "allExpense")?.visible) && < StatisticBlock
          key={5}
          iconColor={COLORS.blue}
          iconUrl={pieIcon}
          bgColor={COLORS.white}
          isDropdown={true}
          data={finStatistic}
        />}
      </div>
      <DataTable
        key={JSON.stringify(tableStructure.map(c => `${c.key}-${c.label}-${c.visible}`))}
        table={{ ...tableColumnType[TableTypeEnum.PROJECTS], columns: tableStructure }}
        data={projects}
        deleteArrFunc={(queryArr) =>
          deleteArrFunc(queryArr, `${API_URL_PROJECT}/archive`, setIsDeleted)
        }
      />
    </AppLayout>
  );
}